function onKeydown(event) {
  const { key } = event;
  event.preventDefault();
  // Accept if space, enter
  if (/( |enter)/i.test(key)) {
    event.target.click();
  }
}

export default {
  bind(el) {
    el.addEventListener('keydown', onKeydown);
  },
  unbind(el) {
    // Remove Event Listeners
    el.removeEventListener('keydown', onKeydown);
  },
};
